import React, { Component } from 'react'
import "../../css/general-style.css"
import '../../css/small-table-responsive.css'
import { NumberFormat } from '../../functions/generalFunctions';
import { pricesFormat } from '../../functions/pricesFormat';
import { AiOutlineCheckCircle, AiOutlineSync, AiOutlineStop } from 'react-icons/ai';

export default class extends Component {

    constructor(props) {
        super(props);
        this.ModalLoading = React.createRef();
    }
    
    state = {

    }

    print() {
        console.log(this.props.data.Months)
    }

    formatBrokenDate(dateStr, locale = 'en-US') {
        if (!dateStr) return '';
        // Receiving: MM/DDTHH:mm:ss.sssZ/YYYY
        const match = dateStr.match(
            /^(\d{1,2})\/(\d{1,2})T(.+)\/(\d{4})$/
        );

        if (!match) return 'Fecha inválida';

        const [, month, day, time, year] = match;

        // ISO Fromat
        const isoDate = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T${time}`;

        const date = new Date(isoDate);

        if (isNaN(date.getTime())) return 'Fecha inválida';

        return date.toLocaleString(locale, {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        })
    }

    selectColor(statusText) {
        const t = (statusText || '').toLowerCase();
        if (t === 'not started') return "status-success";
        if (t === 'in process')  return "status-warning";
        if (t === 'finished')    return "status-danger";
        return "";
    }

    statusIcon(statusText) {
        const t = (statusText || '').toLowerCase();
        if (t === 'not started') return <AiOutlineStop style={{marginRight:4}} />;
        if (t === 'in process')  return <AiOutlineSync  style={{marginRight:4}} />;
        if (t === 'finished')    return <AiOutlineCheckCircle style={{marginRight:4}} />;
        return null;
    }


    render() {
        // Get request status
        const { loading, error, Title } = this.props;

        if (loading) {
            return (
                <div className="card card-skeleton">
                    <div className="skeleton-header" />
                    <div className="skeleton-row" />
                    <div className="skeleton-row" />
                    <div className="skeleton-row" />
                </div>
            );
        }

        if (error) {
            return (
                <div className="card card-error">
                    <h4>{Title}</h4>
                    <p>{error}</p>
                </div>
            );
        }

        return (
            <div className='card'>
                <div className='card-body'>
                    <h6 className='card-title-clean mb-3'>{this.props.Title}</h6>

                    {/* KPI metric row */}
                    <div className='row mb-3'>
                        <div className='col-sm-12 col-md-4 mb-2'>
                            <div className='metric-card status-success'>
                                <p className='metric-label'>Not started</p>
                                <div className='metric-value'>${NumberFormat(pricesFormat(this.props.Totals.NotStarted || 0))}</div>
                            </div>
                        </div>
                        <div className='col-sm-12 col-md-4 mb-2'>
                            <div className='metric-card status-warning'>
                                <p className='metric-label'>In progress</p>
                                <div className='metric-value'>${NumberFormat(pricesFormat(this.props.Totals.InProcess || 0))}</div>
                            </div>
                        </div>
                        <div className='col-sm-12 col-md-4 mb-2'>
                            <div className='metric-card status-danger'>
                                <p className='metric-label'>Finished</p>
                                <div className='metric-value'>${NumberFormat(pricesFormat(this.props.Totals.Finished || 0))}</div>
                            </div>
                        </div>
                    </div>

                    {/* Table */}
                    <div className="tableFixHeadSmall">
                        <table className='table table-clean'>
                            <thead>
                                <tr>
                                    <th>Order No</th>
                                    <th>Type</th>
                                    <th>Customer No</th>
                                    <th>Customer Name</th>
                                    <th>Date</th>
                                    <th>Days</th>
                                    <th><AiOutlineCheckCircle style={{marginRight:4}}/>Status</th>
                                    <th>Sales Person</th>
                                    <th>Invoice?</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.props.data.map((order, o) => (
                                    <tr className={order.ExistInv === 'Yes' ? "status-success" : "status-danger"} key={o}>
                                        <td>{order.SalesOrderNo}</td>
                                        <td>{order.TypeinLetters}</td>
                                        <td>{order.CustomerNo}</td>
                                        <td>{order.BillToName}</td>
                                        <td>{this.formatBrokenDate(order.OrderDate)}</td>
                                        <td className='text-center'>{order.DaysSystem}</td>
                                        <td>
                                            <span className={`dash-status-pill ${this.selectColor(order.StatusText)}`}>
                                                {this.statusIcon(order.StatusText)}
                                                {order.StatusText}
                                            </span>
                                        </td>
                                        <td className='text-center'>{order.SalespersonNo}</td>
                                        <td className='text-center'>{order.ExistInv}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    }
}
